import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function input(theme: Theme): ComponentStyle {
  return {
    componentName: 'input',
    baseStyle: {
      border: `solid 1px ${theme.colors.spark.gray90}`,
      borderRadius: theme.sizes['-3'],
      fontSize: theme.sizes['-1'],
      padding: `${theme.space['2xs']} ${theme.space['xs']}`,
      backgroundColor: theme.colors.foreground,
      fontWeight: 500,

      ['&:focus']: {
        borderColor: theme.colors.spark.gray80
      }
    }
  };
}
